import React from 'react'
import styles from './not-found-page.module.scss'

export default function NotFoundPage() {
    return <>
        <div className={styles.banner}><h1>404</h1></div>
        <p>Page not found.</p>
    </>
}
